import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  Divider,
  TextField,
  InputAdornment,
} from "@mui/material";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
import UserService from "src/service/userService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "User List",
  },
];

const ThanaUserList = () => {
  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [user_data, setUserData] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);
  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("username");

  const fetch_userData = async () => {
    try {
      const res = await UserService.getThanauser({
        district_id: sessionData.data.district_id,
      });
      setUserData(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteThanauser = async (id) => {
    swal({
      title: "Delete User",
      text: "Are you sure you want to delete this User?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await UserService.deleteThanaUser({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetch_userData();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetch_userData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filter_list = user_data.filter((man) => {
    const vehicleTypeDisplay =
      man.vehicle_type?.toLowerCase() === "e"
        ? "ERV"
        : man.vehicle_type?.toLowerCase() === "f"
        ? "Fire Brigade"
        : "";

    return (
      (man.username?.toLowerCase().includes(searchTerm.toLowerCase()) ??
        false) ||
      (man.district_name?.toLowerCase().includes(searchTerm.toLowerCase()) ??
        false) ||
      (vehicleTypeDisplay.toLowerCase().includes(searchTerm.toLowerCase()) ??
        false) ||
      (man.contact?.includes(searchTerm) ?? false)
    );
  });

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "User Name",
      "Contact No",
      "District",
      "Vehicle Type",
    ];

    const data = visibleData.map((man, index) => [
      index + 1,
      man.username,
      man.contact,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "User Details.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };
  return (
    <PageContainer title="User List" description="">
      {/* breadcrumb */}
      <Breadcrumb title="User List" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              User List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            {sessionData.data.user_type === 3 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/addthanauser");
                }}
              >
                <IconPlus width={20} />
              </Button>
            )}
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder="search here"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={
                {
                  // whiteSpace: "nowrap",
                }
              }
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>

                  <TableCell
                    onClick={() => handleSort("username")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      User Name
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "username" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("contact_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Contact No
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "contact_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("email_id")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      E-Mail Id
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "email_id" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("contact_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Police Station Name
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "contact_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    {sessionData.data.user_type === 3 && (
                      <>
                        <Typography
                          style={{ fontSize: "15px", textAlign: "left" }}
                          variant="h6"
                        >
                          Action
                        </Typography>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filter_list.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filter_list
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {index + 1}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man?.username ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man?.contact ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man?.email_id ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "14px" }} variant="h6">
                            {man?.thana_name ?? "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell
                          style={{
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "evenly",
                            marginTop: "22px",
                          }}
                        >
                          {sessionData.data.user_type === 3 && (
                            <>
                              <Link to={`/updatethanauser/${man.id}`}>
                                <ModeEditOutlinedIcon
                                  style={{
                                    color: "green",
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    marginLeft: "10px",
                                  }}
                                />
                              </Link>
                              <DeleteOutlinedIcon
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => deleteThanauser(man.id)}
                              />
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={filter_list.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default ThanaUserList;
